import type { IntegrationRequestFormSchema } from '../../../../models/IntegrationRequest';
import CheckboxListField, { type CheckboxOption } from './CheckboxListField';
import type { Control } from 'react-hook-form';
import FormSection from './FormSection';

interface ApiServicesSectionProps {
  control: Control<IntegrationRequestFormSchema>;
  serviceOptions: CheckboxOption[];
  hasOperator: boolean;
  disabled: boolean;
}

const ApiServicesSection = ({
  control,
  serviceOptions,
  hasOperator,
  disabled,
}: ApiServicesSectionProps) => (
  <FormSection title='Servicios por API'>
    <p className='text-sm text-gray-500'>
      Por API se ofrece solo entrega en el día y envío al interior. SAME-DAY-DELIVERY queda como
      servicio por defecto.
    </p>
    <CheckboxListField
      control={control}
      name='serviceWithOperatorIds'
      options={serviceOptions}
      disabled={disabled}
      emptyMessage={
        hasOperator
          ? 'Este operador no tiene SAME-DAY ni INTERIOR.'
          : 'Primero seleccione el operador.'
      }
    />
  </FormSection>
);

export default ApiServicesSection;
